import { Trans } from '@lingui/react/macro';
import { SparkleIcon } from '@phosphor-icons/react';
import { Folder, InformationCircle } from '@remarkable/ark-icons';
import { Tag, Typography } from '@remarkable/ark-web';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { FlexDivider } from 'src/components/FlexDivider';
import { ConvertToNotebookTooltip } from '../ConvertToNotebookTooltip';

interface DropInfoProps {
  importFiles: () => void;
}

export const DropInfo = ({ importFiles }: DropInfoProps) => {
  return (
    <button
      data-cy="drop-info"
      className="flex size-full cursor-pointer flex-col items-center justify-center gap-24 p-32 text-left transition-all hover:bg-neutral-light-3/50"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23767676' stroke-width='1' stroke-dasharray='8%2c 8' stroke-dashoffset='3' stroke-linecap='butt'/%3e%3c/svg%3e")`,
      }}
      onClick={importFiles}
    >
      <div className="flex flex-col items-center gap-2 lm:flex-row lm:items-start lm:gap-16">
        <Folder size={32} className="mt-4 text-text-muted" />
        <div className="w-4/5 lm:w-auto">
          <Typography variant="body-2xl" className="hidden lm:block">
            <Trans>
              Drag and drop or <strong>browse your files</strong>
            </Trans>
          </Typography>
        </div>
      </div>
      <div className="flex w-auto flex-col lm:flex-row lm:justify-between lm:gap-24">
        <div className="flex flex-col items-center gap-4 xs:flex-row">
          <Typography variant="body-sm" className="text-center text-text-muted">
            <Trans>
              Import DOCX, with <strong>Convert to Notebook</strong>
            </Trans>
            <SparkleIcon
              className="-mt-6 ml-2 inline"
              weight="fill"
              size={16}
            />
            <ConvertToNotebookTooltip
              componentLocation={ComponentLocations.FRONT_PAGE.DROP_ZONE}
            >
              <span className="-mt-2 ml-4 hidden -translate-y-[1px] items-center align-middle xs:inline-flex">
                <InformationCircle size={18} />
              </span>
            </ConvertToNotebookTooltip>
          </Typography>

          <Tag
            className="ml-4 inline-flex bg-paper-5 xs:hidden"
            variant="themed-filled"
            bgColorIntensity={5}
            dataTheme="light-neutral"
          >
            <Trans>BETA</Trans>
          </Tag>
        </div>

        <FlexDivider className="m-auto my-16 w-[40px] border-t-[1.5px] border-l-[1.5px] lm:m-0 lm:w-auto" />
        <Typography variant="body-sm" className="text-center text-text-muted">
          <Trans>Import PDF, JPG, PNG, and EPUB files up to {100} MB.</Trans>
        </Typography>
      </div>
      <Typography
        variant="body-md"
        as="span"
        className="rounded-sm flex w-full items-center justify-center bg-interaction-tertiary px-16 py-[10px] lm:hidden"
      >
        <Trans>Browse files</Trans>
      </Typography>
    </button>
  );
};
